/*
 * Modal showing details of a single API log entry.
 */

import React from "react";
import { FaTimes } from "react-icons/fa";
import i18n from "../../../i18n/i18n.js";

export default function LogDetailModal({ log, onClose, getTextDirection }) {
  const dir = getTextDirection ? getTextDirection() : "ltr";

  if (!log) return null;

  return (
    <div className="fixed inset-0 bg-white/30 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] flex flex-col">
        <div className={`flex items-center justify-between p-4 border-b border-gray-200 ${dir === "rtl" ? "flex-row-reverse" : ""}`}>
          <h2 className="text-xl font-semibold text-gray-900">{i18n.t("logs.logDetails")}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <FaTimes className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">{i18n.t("logs.request")}</h3>
            <div className="bg-gray-50 rounded p-3 space-y-1 text-xs">
              <div><strong>{i18n.t("logs.method")}</strong> {log.method}</div>
              <div><strong>{i18n.t("logs.path")}</strong> {log.path}</div>
              <div><strong>{i18n.t("logs.domain")}</strong> {log.domain || "N/A"}</div>
              <div><strong>{i18n.t("logs.timestamp")}</strong> {new Date(log.createdAt).toLocaleString()}</div>
            </div>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">{i18n.t("logs.response")}</h3>
            <div className="bg-gray-50 rounded p-3 space-y-1 text-xs">
              <div><strong>{i18n.t("logs.status")}</strong> {log.statusCode || "N/A"} {log.statusMessage || ""}</div>
              <div><strong>{i18n.t("logs.duration")}</strong> {log.duration ? `${log.duration}ms` : "N/A"}</div>
              {log.errorMessage && (
                <div className="mt-2 text-red-600">
                  <strong>{i18n.t("logs.error")}</strong> {log.errorMessage}
                </div>
              )}
            </div>
          </div>
          {log.requestBody && (
            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-2">{i18n.t("logs.requestBody")}</h3>
              <pre className="bg-gray-50 rounded p-3 text-xs overflow-x-auto max-h-40 overflow-y-auto">
                {log.requestBody.length > 500
                  ? log.requestBody.substring(0, 500) + " " + i18n.t("logs.truncated")
                  : log.requestBody}
              </pre>
            </div>
          )}
          {log.responseBody && (
            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-2">{i18n.t("logs.responseBody")}</h3>
              <pre className="bg-gray-50 rounded p-3 text-xs overflow-x-auto max-h-40 overflow-y-auto">
                {log.responseBody.length > 500
                  ? log.responseBody.substring(0, 500) + " " + i18n.t("logs.truncated")
                  : log.responseBody}
              </pre>
            </div>
          )}
        </div>
        <div className="p-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="w-full bg-[#46A2F2] text-white px-4 py-2 rounded-md hover:bg-[#0C75D1] text-sm"
          >
            {i18n.t("logs.close")}
          </button>
        </div>
      </div>
    </div>
  );
}
